// src/services/rolesApi.js
//
// Business roles are dynamic — a role is a role-scoped PermissionSet on the
// server, not a hardcoded list here. Anything that shows a role dropdown
// (employees, users, filters) reads from this single endpoint so a role added in
// one place shows up in all of them, including the Dashboard Builder and the
// approval templates.
import API from './api';

// [{ _id, key, name, description, priority, isSystem, dashboardMaxScope, userCount }]
export const fetchRoles = async () => {
  const res = await API.get('/roles');
  return res.data?.data || [];
};

// Create a role (mints the PermissionSet). `copyFromKey` clones another role's
// grants so the new role is usable straight away; omit it to start with none.
export const createRole = async ({ name, key, description, priority, copyFromKey, dashboardMaxScope }) => {
  const res = await API.post('/roles', { name, key, description, priority, copyFromKey, dashboardMaxScope });
  return res.data?.data;
};
